"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const spellCheckService_1 = require("../services/spellCheckService");
const HighlightedText_1 = __importDefault(require("./HighlightedText"));
const SpellCheckDisplay = ({ text, className = '', onDoubleClick, enableSpellCheck = true, // ZAPNUTÝ ve výchozím stavu
showErrors = true, // ZOBRAZIT chyby ve výchozím stavu
searchTerm, // Vyhledávaný termín
precomputedResult = null }) => {
    const [spellCheckResult, setSpellCheckResult] = (0, react_1.useState)(precomputedResult);
    // Spell check when text changes (only if enabled and no precomputed result)
    (0, react_1.useEffect)(() => {
        if (!enableSpellCheck)
            return;
        if (precomputedResult)
            return;
        const timeoutId = setTimeout(async () => {
            if (!text.trim())
                return setSpellCheckResult(null);
            if (text.length > 1000) {
                console.log('Skipping spell check for long text (>1000 chars)');
                setSpellCheckResult(null);
                return;
            }
            try {
                const result = await spellCheckService_1.spellCheckService.checkSpelling(text);
                setSpellCheckResult(result);
                try {
                    const anyWindow = window;
                    if (anyWindow.__spellCacheUpdate) {
                        anyWindow.__spellCacheUpdate(text, result);
                    }
                }
                catch { }
            }
            catch (error) {
                console.error('Spell check failed:', error);
                setSpellCheckResult(null);
            }
        }, 500);
        return () => clearTimeout(timeoutId);
    }, [text, enableSpellCheck, precomputedResult]);
    // Generate highlighted text HTML
    const generateHighlightedText = () => {
        if (!spellCheckResult || spellCheckResult.errors.length === 0) {
            return text;
        }
        let highlightedText = text;
        let offset = 0;
        // Sort errors by position to avoid conflicts
        const sortedErrors = [...spellCheckResult.errors].sort((a, b) => a.position.start - b.position.start);
        for (const error of sortedErrors) {
            const start = error.position.start + offset;
            const end = error.position.end + offset;
            const word = highlightedText.substring(start, end);
            const highlightedWord = `<span class="spell-error-display" title="Možná chyba: ${error.word}">${word}</span>`;
            highlightedText = highlightedText.substring(0, start) +
                highlightedWord +
                highlightedText.substring(end);
            offset += highlightedWord.length - word.length;
        }
        return highlightedText;
    };
    // Pokud máme spell check výsledky a chyby, použijeme původní logiku
    if (spellCheckResult && spellCheckResult.errors.length > 0 && showErrors) {
        return ((0, jsx_runtime_1.jsx)("div", { className: `spell-check-display ${className}`, onDoubleClick: onDoubleClick, dangerouslySetInnerHTML: {
                __html: generateHighlightedText()
            } }));
    }
    // Jinak použijeme HighlightedText pro vyhledávání
    return ((0, jsx_runtime_1.jsx)("div", { className: `spell-check-display ${className}`, onDoubleClick: onDoubleClick, children: (0, jsx_runtime_1.jsx)(HighlightedText_1.default, { text: text, searchTerm: searchTerm }) }));
};
exports.default = SpellCheckDisplay;
